export default function adminDataSelector(func) {
  return func((state) => state.adminReducer);
}
